import React from 'react';
import bgImg from '@nsgscholarship/assets/images/banner-bg-2023.jpg';
import mobileBgImg from '@nsgscholarship/assets/images/mobile-banner-bg-2023.png';
import awardSvg from '@nsgscholarship/assets/icons/award.svg';
import { $t } from "@/modules/i18n";
import { transformArray } from '@/utils/helper';

export default ({ message }) => {
  const descs = transformArray(message.introDesc);
  return (
    <section className="banner">
      <img className="background-img" src={bgImg} alt="banner image" />
      <img className="mobile-background-img" src={mobileBgImg} alt="banner image" />
      {/* <div className="background"></div> */}
      <div className="intro-container">
        <div className="intro-title">{$t(message.title)}</div>
        <div className="intro-content">
          <div className="intro-img">
            <img src={awardSvg} alt="award image"/>
          </div>
          <div className="intro-text">
            {
              descs.map((desc, index) => {
                return <p key={index} className="intro-desc">{$t(desc)}</p>
              })
            }
            <div className="apply-info">
              <div className="apply">
                {$t(message.applyText)}
                <span className="apply-num">
                  {$t(message.applyNum)}
                </span>
                {$t(message.applyUnit)}
              </div>
              <div className="award">
                {$t(message.awardText)}
                <span className="award-num">
                  {$t(message.awardNum)}
                </span>
                {$t(message.awardUnit)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
  
}